import React from "react";
import { BaseModal } from "@/react/components/editors/base/BaseModal";
import { BaseModalBody } from "@/react/components/editors/base/BaseModalBody";
import { Input } from "@/modern/components/ui/input";
import { Search } from "lucide-react";
import { TaskFinderProvider, useTaskFinderContext } from "./context/TaskFinderContext";
import { TaskFinderContent } from "./TaskFinderContent";
import { Button } from "../../ui/button";

interface TaskFinderEditorProps {
  record: {
    onTaskClick?: (params: { record: any }) => void;
    canInsert?: boolean;
    canDrag?: boolean;
    resourceRecord?: any;
    eventRecord?: any;
    scheduler?: any;
    selectedDate?: Date;
    point?: [number, number];
    [key: string]: any;
  };
  onClose: () => void;
  editorInstance?: any;
  context?: any; // eslint-disable-line @typescript-eslint/no-unused-vars
}

export const TaskFinderEditor = ({ record, onClose, editorInstance }: TaskFinderEditorProps) => {
  return (
    <TaskFinderProvider record={record} onClose={onClose}>
      <TaskFinderEditorContent record={record} onClose={onClose} editorInstance={editorInstance} />
    </TaskFinderProvider>
  );
};

const TaskFinderEditorContent = ({ record, onClose, editorInstance }: TaskFinderEditorProps) => {
  const { searchValue, handleSearchChange, handleSearchClear, handleClose, resourceLabel, submitButtonText, showSubmitButton, selectedTasks, handleSubmit } = useTaskFinderContext();
  const { point } = record;
  const [x, y] = point || [];

  return (
    <BaseModal
      record={record}
      onClose={onClose}
      title=""
      description=""
      editorInstance={editorInstance}
      hideMenu={true}
      size={{
        width: "25rem",
        height: "25rem",
        maxHeight: "100vh",
        maxWidth: "100vw",
        minWidth: "25rem",
        minHeight: "25rem"
      }}
      modal={false}
      version={undefined}
      swivuAssistanceConfig={undefined}
      headerIconCls=""
      headerRenderer={() => (
        <div className="drag-handle flex items-center gap-2 px-4 py-3 bg-background">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
            <Input type="text" placeholder="Task Finder" value={searchValue} onChange={handleSearchChange} className="pl-9 pr-16" autoFocus />
            {searchValue && (
              <button onClick={handleSearchClear} className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground hover:text-foreground">
                Clear
              </button>
            )}
          </div>
          <button onClick={handleClose} className="text-sm px-2 py-1 rounded text-muted-foreground hover:text-foreground hover:bg-accent">
            ESC
          </button>
        </div>
      )}
      footerRenderer={
        showSubmitButton
          ? () => {
              return (
                <div className="border-t border-border bg-background w-full">
                  <div className="flex flex-col items-center gap-2 p-3">
                    {resourceLabel && <div className="text-sm text-center text-muted-foreground w-full">{resourceLabel}</div>}
                    <Button onClick={handleSubmit} disabled={selectedTasks.length === 0} className="w-full" variant="outline">
                      {submitButtonText}
                    </Button>
                  </div>
                </div>
              );
            }
          : undefined
      }
      defaultPosition={{ x, y }}
      footerClassName="!p-0"
    >
      <BaseModalBody className="!p-0 overflow-hidden">
        <TaskFinderContent />
      </BaseModalBody>
    </BaseModal>
  );
};
